import React, { memo } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import { useStyles } from './styles';

const ButtonGroup = ({ handleClick }) => {
  const classes = useStyles();

  return (
    <Box className={classes.box}>
      <Typography className={classes.boxTitle}>Bitter</Typography>
      <Typography className={classes.boxQuestion}>
        How about some bitter notes?
      </Typography>
      <div className={classes.buttonGroup}>
        <Button
          size="small"
          className={classes.yesnoBtn}
          onClick={handleClick('no')}
        >
          No
        </Button>
        <Button
          size="small"
          className={classes.yesnoBtn}
          onClick={handleClick('yes')}
        >
          Yes
        </Button>
      </div>
    </Box>
  );
};

export default memo(ButtonGroup);
